import { lazy, useEffect, useMemo } from "react";

import { Outlet } from "react-router-dom";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import Loading from "../components/loading";

// Layouts
import RouterLayout from "../pages/layouts/router-layout";
import UploadLayout from "../pages/layouts/upload-layout";

const NoMatch = lazy(() => import("../pages/NoMatch"));
const Downloader = lazy(() => import("../pages/Downloader"));
const FileRequestsLayout = lazy(() =>
  import("../pages/layouts/file-requests-layout")
);
const FileRequestsPublicPage = lazy(() =>
  import("../pages/FileRequestsPublicPage")
);

function Router(props) {
  const { children } = props;

  const future = useMemo(() => {
    return {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    };
  }, []);

  const RedirectHome = (props) => {
    useEffect(() => {
      window.location.href = `https://${process.env.REACT_APP_DOMAIN}`;
    }, []);
    return <Outlet />;
  };

  const router = useMemo(() => {
    return createBrowserRouter([
      {
        path: "",
        element: <RouterLayout />,
        children: [
          {
            path: "",
            element: <UploadLayout />,
            children: [
              {
                path: "",
                element: <RedirectHome />,
                errorElement: <NoMatch />,
              },
              {
                // Transferencia personalizada: {username}.{domain}/{slug}.
                // El slug va en la raíz (sin prefijo), tal y como lo construye
                // el dominio: `https://${username}.${domain}/${customTransferId}`.
                // React Router resuelve antes la ruta estática "r" (file
                // requests) que esta dinámica, por lo que no colisionan.
                path: ":id",
                element: <Downloader />,
                errorElement: <NoMatch />,
              },
              {
                path: "*",
                element: <NoMatch />,
                errorElement: <NoMatch />,
              },
            ],
          },
          {
            // /r/:id como HERMANA de UploadLayout (igual que el dominio): solo
            // la envuelve FileRequestsLayout, sin el chrome del UploadLayout
            // (header/footer/landing). El layout lee el id con useMatch("/r/:id").
            path: "r",
            element: <FileRequestsLayout />,
            children: [
              {
                path: ":id",
                element: <FileRequestsPublicPage />,
                errorElement: <NoMatch />,
              },
              {
                path: "*",
                element: <NoMatch />,
                errorElement: <NoMatch />,
              },
            ],
          },
        ],
      },
    ]);
  }, []);

  return (
    <RouterProvider
      future={future}
      router={router}
      fallbackElement={<Loading />}
    >
      {children}
    </RouterProvider>
  );
}

export default Router;
